module.exports = __webpack_public_path__ + "img/product-details-3.947ac3f6.jpg";